import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import type { RegisterSearch } from './register'
import { rootRoute } from './root'

const AffiliateAds = lazyRouteComponent(() => import('../pages/affiliate-ads'))

export const affiliateAdsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/affiliate-ads',
  component: AffiliateAds,
  validateSearch: (search: Record<string, unknown>): RegisterSearch => {
    return search
  },
})
